// React
import React from 'react';
import { useSelector } from 'react-redux';

// components
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { ADGMImage, ADGMPanel, ReviewADGMPanelDetails } from 'aurora-components';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

// utils
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

const ProjectDetails = ({ classes, project }) => {
  const isAr = useSelector(state => state.language.locale === 'ar');
  const PROJECT_LABELS_AND_VALUES = [
    {
      label: keyEmptyCheck('municipality'),
      valueProperty: 'municipalityEn',
      valuePropertyAr: 'municipalityAr',
    },
    {
      label: keyEmptyCheck('district'),
      valueProperty: 'districtEn',
      valuePropertyAr: 'districtAr',
    },
    {
      label: keyEmptyCheck('community'),
      valueProperty: 'communityEn',
      valuePropertyAr: 'communityAr',
    },
    {
      label: keyEmptyCheck(isAr ? 'project_name_ar' : 'project_name_en'),
      valueProperty: 'name',
      valuePropertyAr: 'nameAr',
    },
    {
      label: keyEmptyCheck('project_number'),
      valueProperty: 'projectNumber',
    },
    {
      label: keyEmptyCheck('project_category'),
      valueProperty: 'projectCategoryDesc',
    },
    {
      label: keyEmptyCheck('project_type'),
      valueProperty: 'projectPropertyType',
    },
    {
      label: keyEmptyCheck('project_status'),
      valueProperty: 'status',
    },
    {
      label: keyEmptyCheck('completion_percentage'),
      customRender: values => (
        <ADGMItemDetails
          label={keyEmptyCheck('completion_percentage')}
          value={values?.progressPercentage ? `${values?.progressPercentage} %` : ''}
        />
      ),
    },
    {
      label: keyEmptyCheck('registration_type'),
      customRender: values => (
        <ADGMItemDetails
          label={keyEmptyCheck('registration_type')}
          value={values?.isOffPlan ? keyEmptyCheck('offPlan') : keyEmptyCheck('Completed')}
        />
      ),
    },
    {
      label: keyEmptyCheck('mortgage_status'),
      customRender: values => (
        <ADGMItemDetails
          label={keyEmptyCheck('mortgage_status')}
          value={values?.isMortgaged ? keyEmptyCheck('mortgage') : keyEmptyCheck('Not_Mortgaged')}
        />
      ),
    },
  ];

  return (
    <>
      <ADGMPanel title='project_details' classes={{ titleHead: classes.titleHead }}>
        {!isEmpty(project) && (
          <>
            <div className={classes.detailsWrapper}>
              <Grid container>
                {project?.mainImage && (
                  <Hidden mdUp>
                    <Grid item xs={12}>
                      <ADGMImage
                        className={classes.titleImage}
                        name='Project.svg'
                        alt='project details image'
                        httpURL={project?.mainImage}
                      />
                    </Grid>
                  </Hidden>
                )}
                <Grid item xs={12} md={project?.mainImage ? 9 : 12}>
                  <Grid container>
                    <ReviewADGMPanelDetails labelAndValues={PROJECT_LABELS_AND_VALUES} data={project} withoutPanel />
                  </Grid>
                </Grid>
                {project?.mainImage && (
                  <Hidden smDown>
                    <Grid item md={3}>
                      <ADGMImage
                        className={classes.titleImage}
                        name='Project.svg'
                        alt='property details image'
                        httpURL={project?.mainImage}
                      />
                    </Grid>
                  </Hidden>
                )}
              </Grid>
            </div>
          </>
        )}
      </ADGMPanel>
    </>
  );
};

ProjectDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProjectDetails);
